import React from "react";
import {
  Button,
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import {
  CatalogoItem,
  ClientInfo,
  ClientModalContentView,
  ClientModalView,
  NewClientForm,
} from "../constants";

type ClientModalProps = {
  isOpen: boolean;
  view: ClientModalView;
  contentView: ClientModalContentView;
  clientSearchTerm: string;
  onClientSearchTermChange: (value: string) => void;
  onSearch: () => void;
  searchResults: ClientInfo[];
  onSelectClient: (client: ClientInfo) => void;
  onToggle: () => void;
  onChangeView: (view: ClientModalView) => void;
  newClientData: NewClientForm;
  onNewClientChange: (field: keyof NewClientForm, value: string) => void;
  onSaveNewClient: () => void;
  onApplySinNombre: () => void;
  documentoTipos: CatalogoItem[];
  documentoTipoId: number | null;
  onDocumentoTipoChange: (id: number | null) => void;
};

const ClientModal: React.FC<ClientModalProps> = ({
  isOpen,
  view,
  contentView,
  clientSearchTerm,
  onClientSearchTermChange,
  onSearch,
  searchResults,
  onSelectClient,
  onToggle,
  onChangeView,
  newClientData,
  onNewClientChange,
  onSaveNewClient,
  onApplySinNombre,
  documentoTipos,
  documentoTipoId,
  onDocumentoTipoChange,
}) => (
  <Modal isOpen={isOpen} toggle={onToggle} size="lg">
    <ModalHeader toggle={onToggle}>Cliente</ModalHeader>
    <ModalBody>
      {view === "search" && (
        <>
          <div className="d-flex gap-2 mb-3">
            <Input
              placeholder="Buscar cliente por nombre o RUC"
              value={clientSearchTerm}
              onChange={(event) => onClientSearchTermChange(event.target.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  event.preventDefault();
                  onSearch();
                }
              }}
            />
            <Button color="outline-primary" onClick={() => onChangeView("new")}>
              Nuevo cliente
            </Button>
          </div>
          <Table hover>
            <thead>
              <tr>
                <th>Razón social</th>
                <th>Documento</th>
                <th>Teléfono</th>
                <th>Email</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {searchResults.length === 0 ? (
                <tr>
                  <td colSpan={5} className="text-center text-muted">
                    Ingresa un criterio y presiona Enter.
                  </td>
                </tr>
              ) : (
                searchResults.map((client) => (
                  <tr key={client.id}>
                    <td>{client.razon_social}</td>
                    <td>{client.documento}</td>
                    <td>{client.telefono}</td>
                    <td>{client.email}</td>
                    <td className="text-end">
                      <Button
                        color="outline-success"
                        size="sm"
                        onClick={() => onSelectClient(client)}
                      >
                        Seleccionar
                      </Button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </>
      )}
      {view === "new" && (
        <>
          <div className="d-flex justify-content-between mb-3">
            <h6>Nuevo cliente</h6>
            <Button color="link" onClick={() => onChangeView("search")}>
              Volver
            </Button>
          </div>
          <Row className="g-3">
            <Col md={6}>
              <Label>Tipo de documento</Label>
              <Input
                type="select"
                value={documentoTipoId ?? ""}
                onChange={(event) =>
                  onDocumentoTipoChange(
                    event.target.value ? Number(event.target.value) : null,
                  )
                }
              >
                <option value="">Seleccioná tipo</option>
                {documentoTipos.map((tipo) => (
                  <option key={tipo.id} value={tipo.id}>
                    {tipo.descripcion || tipo.codigo || `#${tipo.id}`}
                  </option>
                ))}
              </Input>
            </Col>
            <Col md={6}>
              <Label>Razón social</Label>
              <Input
                value={newClientData.razonSocial}
                onChange={(event) => onNewClientChange("razonSocial", event.target.value)}
              />
            </Col>
            <Col md={6}>
              <Label>Documento / RUC</Label>
              <Input
                value={newClientData.documento}
                onChange={(event) => onNewClientChange("documento", event.target.value)}
              />
            </Col>
            <Col md={6}>
              <Label>Nombre fantasía</Label>
              <Input
                value={newClientData.nombreFantasia ?? ""}
                onChange={(event) => onNewClientChange("nombreFantasia", event.target.value)}
              />
            </Col>
            <Col md={6}>
              <Label>Teléfono</Label>
              <Input
                value={newClientData.telefono ?? ""}
                onChange={(event) => onNewClientChange("telefono", event.target.value)}
              />
            </Col>
            <Col md={6}>
              <Label>Email</Label>
              <Input
                value={newClientData.email ?? ""}
                onChange={(event) => onNewClientChange("email", event.target.value)}
              />
            </Col>
            <Col className="text-end">
              <Button color="primary" size="sm" onClick={onSaveNewClient}>
                Guardar y seleccionar
              </Button>
            </Col>
          </Row>
        </>
      )}
      {view === "sinNombreConfirm" && (
        <div className="text-center">
          <p>
            Querés dejar la venta como <strong>Sin nombre (SIN RUC)</strong>?
          </p>
          <div className="d-flex justify-content-center gap-2">
            <Button
              color="outline-secondary"
              size="sm"
              onClick={() => onChangeView(contentView)}
            >
              No, volver
            </Button>
            <Button color="primary" size="sm" onClick={onApplySinNombre}>
              Sí, asignar
            </Button>
          </div>
        </div>
      )}
    </ModalBody>
  </Modal>
);

export default ClientModal;
